import { api } from '@/scripts/api';

export const SharedAssetService = {
    /**
     * Get shared assets based on the query options.
     *
     * @param {{
     *      query?: ODataQueryOptions;
     *      signal?: AbortSignal;
     * }} options
     */
    async getSharedAssets(options) {
        const queryParams = api.buildODataQuery(options.query ?? {});
        const endpoint = `/service/SharedAssets${queryParams}`;
        return api.ajax({
            method: 'GET',
            url: endpoint,
            signal: options.signal,
        });
    },
};